import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './EnrollSuccess.scss';
import Logout from '../../../shared/Logout/Logout';
import imprivataIcon from '../../Login/Icons/imprivata.svg';

class EnrollSuccess extends Component {
  static propTypes = {
    /** The header text for this enrollment screen */
    headerTitle: PropTypes.string,
    /** The image to be displayed on success for this modality */
    enrollImage: PropTypes.string,
    /** The text for the ok button */
    buttonText: PropTypes.string,
    /** Function executed when the ok button is clicked */
    onButtonClicked: PropTypes.func,
    /** The component to be used for logout */
    logoutComponent: PropTypes.object,
    /** The width of the image */
    imageWidth: PropTypes.string,
    /** The DOM tree/component to be used for the footer */
    footer: PropTypes.object,
    canSkipEnrollment: PropTypes.bool,
  };
  static defaultProps = {
    enrollImage: './enroll_success_animation.gif',
    headerTitle: 'Imprivata ID is enrolled',
    buttonText: 'Next: enroll backup method',
    logoutComponent: <Logout/>,
  };
  render() {
    return (
      <div className='CIDRA'>
        {this.props.logoutComponent}
        <div className='login-container'>
          <div className='form-group login-header'>
            {
              this.props.headerTitle ? (
                <div>
                  <img id='EnrollSuccess_header_image' className='enroll-success-label' src={require('./successicon_30x30.png')} alt='' />
                  <h2 className='header-title enroll-header-title header-with-image'>{this.props.headerTitle}</h2>
                </div>
              ) : null
            }
          </div>
          <div className='form-group success-description larger-margin'>
            <p>
              {this.props.children}
            </p>
          </div>
          <br/>
          <div className='form-group text-center larger-margin'>
            <img id='EnrollSuccess_EnrollImage' className='success-image' src={this.props.enrollImage} alt='' width={this.props.imageWidth} />
          </div>
          <div className='form-group text-center bottom-btn'>
            <button
              id='EnrollSuccess_submit_button'
              className='btn btn-primary'
              onClick={this.props.onButtonClicked}>
              {this.props.buttonText}
            </button>
          </div>
        </div>
        { this.props.footer }
        <hr className='Footer-hr'/>
        <img className='Footer' src={imprivataIcon} alt='logo'/>
      </div>
    );
  }
}

export default EnrollSuccess;
